<!-- `?? []` renders the "no removed items" message while the query is still
loading, rather than nothing at all. -->
@if (removedItemsQuery.data() ?? []; as removedItems) {
  <div class="removed-items">
    <!-- Toolbar with Restore All button -->
    @if (removedItems.length > 0) {
      <div class="removed-items-toolbar">
        <sui-button
          variant="danger"
          [leadingIcon]="['fas', 'trash-arrow-up']"
          (click)="removeAllItems()"
        >
          {{ "filters.button.restore-all" | translate }}
        </sui-button>
      </div>
    }
    @if (removedItems.length > 0) {
      @for (item of removedItems; track trackByRemovedItem($index, item)) {
        <div class="removed-item">
          <!-- Type icon (SOURCE vs POST) -->
          <fa-icon
            class="type-icon"
            [icon]="
              item.object_class_id === NomObjectClass.SOURCE
                ? ['fas', 'rss']
                : ['fas', 'newspaper']
            "
            [title]="
              item.object_class_id === NomObjectClass.SOURCE
                ? 'Source'
                : 'Article'
            "
            aria-hidden="true"
          ></fa-icon>
          <div class="title">
            <a href="{{ item.url }}" target="_blank">{{ item.title }}</a>
          </div>
          <!-- Remove action -->
          <fa-icon
            class="remove-icon"
            [icon]="['fas', 'trash-arrow-up']"
            (click)="removeSingleItem(item)"
            [suiTooltip]="'removed-items.tooltip.restore' | translate"
            [attr.aria-label]="'removed-items.tooltip.restore' | translate"
          ></fa-icon>
        </div>
      }
    } @else {
      <div class="no-items-message">
        {{ "removed-items.message.there-are-no-removed-items" | translate }}
      </div>
    }
  </div>
}
